"use client";
const t = [
  "documentation",
  "site",
  "discourse_post",
  "github_issue",
  "github_discussion",
  "stackoverflow_question",
  "discord_forum_post",
  "discord_message",
  "custom_question_answer"
], s = {
  type: "object",
  properties: {
    links: {
      anyOf: [
        {
          type: "array",
          items: {
            type: "object",
            properties: {
              label: {
                type: ["string", "null"]
              },
              url: {
                type: "string"
              },
              title: {
                type: ["string", "null"]
              },
              description: {
                type: ["string", "null"]
              },
              type: {
                anyOf: [
                  {
                    anyOf: [
                      {
                        type: "string",
                        enum: t
                      },
                      {
                        type: "string"
                      }
                    ]
                  },
                  {
                    type: "null"
                  }
                ]
              },
              breadcrumbs: {
                anyOf: [
                  {
                    type: "array",
                    items: {
                      type: "string"
                    }
                  },
                  {
                    type: "null"
                  }
                ]
              }
            },
            required: ["url"],
            additionalProperties: !0
          }
        },
        {
          type: "null"
        }
      ]
    },
    text: {
      type: "string"
    }
  },
  required: ["text"],
  additionalProperties: !1,
  $schema: "http://json-schema.org/draft-07/schema#"
}, i = {
  type: "function",
  function: {
    name: "provideLinks",
    description: "Provides links",
    parameters: s,
    function: (e) => e,
    parse: JSON.parse
  }
};
export {
  i as provideLinksTool
};
